<rlst-horizontal-scrollable-container *ngIf="hasSelectedLayers$ | async">
  <i class="js-left-scroll-btn arrow-container far fa-chevron-left">
    <span class="sr-only">Scroll Left</span>
  </i>
  <ul class="layer-wrapper list-unstyled">
    <li class="layer-item d-flex" *ngFor="let layer of boundaryLayers$ | async; trackBy: trackByLayerId">
      <rlst-layers-legend-item [layer]="layer" (closeLayer)="closeBoundaryLayer($event)">
      </rlst-layers-legend-item>
    </li>

    <li class="layer-item d-flex" *ngFor="let layer of distressedPropertiesLayers$ | async; trackBy: trackByLayerId">
      <rlst-layers-legend-item [layer]="layer" (closeLayer)="closeDistressedPropertyLayer($event)">
      </rlst-layers-legend-item>
    </li>

    <li class="layer-item d-flex" *ngFor="let layer of salesValuesLayers$ | async; trackBy: trackByLayerId">
      <rlst-layers-legend-item [layer]="layer" (closeLayer)="closeSalesValuesLayer($event)">
      </rlst-layers-legend-item>
    </li>

    <li class="layer-item d-flex" *ngFor="let layer of mlsListingsLayers$ | async; trackBy: trackByLayerId">
      <rlst-layers-legend-item [layer]="layer" (closeLayer)="closeMlsListingsLayer($event)">
      </rlst-layers-legend-item>
    </li>

    <li class="layer-item d-flex" *ngFor="let layer of locationInformationLayers$ | async; trackBy: trackByLayerId">
      <rlst-layers-legend-item [layer]="layer" (closeLayer)="closeLocationInformationLayer($event)">
      </rlst-layers-legend-item>
    </li>

    <li class="layer-item d-flex" *ngFor="let layer of propertyCharacteristics$ | async; trackBy: trackByLayerId">
      <rlst-layers-legend-item [layer]="layer" (closeLayer)="closePropertyCharacteristic()">
      </rlst-layers-legend-item>
    </li>
  </ul>
  <i class="js-right-scroll-btn arrow-container far fa-chevron-right">
    <span class="sr-only">Scroll Right</span>
  </i>
</rlst-horizontal-scrollable-container>
